export default __webpack_public_path__ + "static/media/Empowered.a28c35bf.webp";